export default "/kiban/_next/static/images/controlWiring-926dc3312268cd61a81718ca96035261.png";